import SocialBar from "../components/SocialBar/SocialBar";

export default function Facturacion() {
  return (
    <section
      className="bg-dark-gray relative text-white px-6 md:px-12 lg:px-20 py-12 md:py-20 bg-cover bg-center"
      style={{ backgroundImage: "url('/images/fondoBlanco.webp')" }}
    >
      {/* dark overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>

      <div className="relative mx-auto text-center max-w-7xl">
        {/* --- Header --- */}
        <h2 className="text-white text-4xl md:text-6xl font-extrabold mb-6 md:mb-10">
          FACTURACIÓN
        </h2>

        <p className="text-gray-300 text-lg md:text-2xl mb-16 max-w-4xl mx-auto px-4">
          Obtén tu comprobante fiscal de manera rápida y sencilla.
        </p>

        {/* --- Content --- */}
        <div className="text-left mx-auto max-w-5xl space-y-10 text-gray-200 text-lg md:text-xl leading-relaxed px-4">
          <p>
            En <strong>Omova Carbon Fiber</strong>, facilitamos el proceso de
            facturación para que puedas obtener tu comprobante fiscal de manera
            rápida y sencilla.
          </p>

          <section>
            <h3 className="text-2xl font-bold mb-4">Solicitud de Factura</h3>
            <p>
              Una vez que el pago sea confirmado, la factura será generada y
              cargada automáticamente en la orden de compra de tu cuenta.
            </p>
          </section>

          <section>
            <h3 className="text-2xl font-bold mb-4">Envío de Factura</h3>
            <p>
              Si prefieres recibir tu factura directamente, podemos enviártela a
              través de WhatsApp. Para ello, indícalo al momento de la compra o
              contáctanos por WhatsApp con tu número de orden y los datos
              necesarios para la facturación.
            </p>
          </section>

          <section>
            <p>
              Para cualquier consulta o asistencia adicional, comunícate con
              nosotros en{" "}
              <a
                href="mailto:contacto@omova.com.mx"
                className="text-primary-green underline hover:text-green-400 transition-colors"
              >
                contacto@omova.com.mx
              </a>
              .
            </p>
          </section>
          <SocialBar />
        </div>
      </div>
    </section>
  );
}
